import styled, { css } from 'styled-components';

export const Container = styled.div`
  margin-top: 25px;
  padding: 24px 16px 29px;
  border-radius: ${({ theme }) => theme.borderRadius};
  background-color: ${({ theme }) => theme.white};

  ${({ brand }) =>
    brand === 'shop' &&
    css`
      padding: 24px 24px 29px;
      ${Button} {
        font-family: 'Roboto';
      }
    `}

  @media (min-width: 768px) {
    padding: 0;
    margin-top: 35px;
    margin-bottom: 35px;
  }
`;

export const Title = styled.strong`
  display: block;
  font-size: 24px;
  line-height: 28px;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.grey.darker};
`;

export const Description = styled.p`
  font-size: 16px;
  line-height: 18px;
  margin-bottom: 32px;
  color: ${({ theme }) => theme.grey.dark};

  @media (min-width: 768px) {
    margin-bottom: 48px;

    span {
      display: block;
    }
  }
`;

export const Button = styled.button`
  font-size: 20px;
  font-weight: 700;
  width: 100%;
  border: none;
  height: 55px;
  color: ${({ theme }) => theme.white};
  border-radius: ${({ theme }) => theme.borderRadius};
  background-color: ${({ theme }) => theme.buttonPrimaryColor};
  cursor: pointer;
`;
